<template>
  <div class="big-box">
    <div class="mainline">
      <span class="primary">
        {{ toughnessBonus }}
      </span>
    </div>
    <label class="has-toggle" @click="toggleState = !toggleState">
      <slot>Toughness</slot>
    </label>
    <div v-if="toggleState" class="text-center">
      <under-input v-model.number="defense.toughnessBonus" type="number">Bonus</under-input>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Toggle from "../shared/_Toggle.vue";
import UnderInput from "../shared/_UnderInput.vue";

export default {
  name: "big-boxes-charisma",
  components: {
    Toggle,
    UnderInput
  },
  data() {
    return {
      toggleState: false
    };
  },
  computed: {
    ...mapState({
      ruleset: state => state.characters.current.ruleset,
      attributes: state => state.characters.current.attributes,
      defense: state => state.characters.current.defense
    }),
    vigor() {
      return this.attributes.find(x => x.name === "vigor");
    },
    toughnessBonus() {
      let base = 2;
      let score = isFinite(this.vigor.score) ? this.vigor.score / 2 : 0;
      let armorBonus = this.defense.armorClass.armor.bonus;
      let bonus = isFinite(this.defense.toughnessBonus)
        ? this.defense.toughnessBonus
        : 0;
      return base + score + armorBonus + bonus;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
